import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  content: {
    '&:not(:last-of-type)': {
      marginBottom: theme.spacing('xlarge'),
    },
  },
}));
